// FQ開発環境@AWS
export const API_BASE_URI = "https://develop.sx-progress.work/api/v1";
